(() => {
document.addEventListener("DOMContentLoaded", function() {
    var link = document.createElement("link");
    link.rel = "manifest";
    link.href = "manifest.json";
    document.head.appendChild(link);
});

})();
//# sourceMappingURL=manifestLoader.js.map
